import { TYPES } from "./bailiff_auth.type";

const initState = {
  isLogged: null,
  uid: null,
  permissions: [],
  //
  register: null,
  step: 0,
  lastMail: null,
};

const bailiffAuthReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPES.FIREBASE_AUTH_STATUS:
      return {
        ...state,
        isLogged: payload,
      };
    case TYPES.FIREBASE_AUTH_UID:
      return {
        ...state,
        uid: payload,
      };
    case TYPES.FIREBASE_AUTH_PERMISSIONS:
      return {
        ...state,
        permissions: payload,
      };
    case TYPES.FIREBASE_AUTH_REGISTER_SUCCESS:
      return {
        ...state,
        register: payload,
      };
    case TYPES.FIREBASE_AUTH_REGISTER_STEP:
      return {
        ...state,
        step: payload,
      };
    case TYPES.FIREBASE_AUTH_REGISTER_LASTMAIL:
      return {
        ...state,
        lastMail: payload,
      };
    default:
      return state;
  }
};

export default bailiffAuthReducer;
